<template>
  <AbstractSelectMultiple
    :filter="filter"
    :items="items"
    :item-label="itemLabel"
    :item-value="itemValue"
    :active-filters="activeFilters"
    :disabled="!isAgendaActive"
    :has-search="items.length > 5"
    @reset-filter="handleResetFilter"
    @add-filter-item="handleAddFilterItem"
    @remove-filter-item="handleRemoveFilterItem"
  >
    <template #label>
      <slot />

      <span
        class="badge-tag"
        :style="{
          backgroundColor: getBadgeColor(filter).backgroundColor,
          color: getBadgeColor(filter).color,
        }"
      >
        <template v-if="isAgendaActive">
          {{ activeFilters.length ? activeFilters.length : "Tout" }}
        </template>
        <template v-else> / </template>
      </span>
    </template>

    <template #badge>
      <SwitchToggle
        :checked="isAgendaActive"
        :color="getBadgeColor(filter).backgroundColor"
        tabindex="0"
        @update:checked="toggleActiveValue"
        @keydown.enter.prevent="toggleActiveValue"
      />
    </template>
  </AbstractSelectMultiple>
</template>

<script setup>
import SwitchToggle from "@follaw-fr/components/reusable/atoms/SwitchToggle.vue";
import AbstractSelectMultiple from "../abstract/AbstractSelectMultiple.vue";

const props = defineProps({
  filter: {
    type: String,
    required: true,
  },
  isAgendaActive: {
    type: Boolean,
    default: true,
  },
  items: {
    type: Array,
    required: true,
    default() {
      return [];
    },
  },
  itemLabel: {
    type: String,
    default: null,
  },
  itemValue: {
    type: String,
    default: null,
  },
  activeFilters: {
    type: Array,
    default() {
      return [];
    },
  },
  hasSearch: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  "resetFilter",
  "addFilterItem",
  "removeFilterItem",
  "activateAgenda",
  "deactivateAgenda",
]);

// Method to assign backgroundColor and color based on filter name
const getBadgeColor = (filter) => {
  const colorMapping = {
    agenda_guests: { backgroundColor: "#FF941E", color: "var(--clr-n8)" },
    agenda_government: { backgroundColor: "#67b7ff", color: "var(--clr-n8)" },
    agenda_sn: { backgroundColor: "#00D1A2", color: "var(--clr-n8)" },
    agenda_an: { backgroundColor: "#FF1047", color: "var(--clr-n8)" },
    agenda_others: { backgroundColor: "#E3008C", color: "#FFF" },
    ministres: { backgroundColor: "#E3008C", color: "var(--clr-n8)" },
  };

  const defaultColor = "var(--clr-p2)";

  return colorMapping[filter.toLowerCase()] || defaultColor;
};

const handleResetFilter = (filter) => {
  emit("resetFilter", filter);
};

const handleAddFilterItem = (item) => {
  emit("addFilterItem", item);
};

const handleRemoveFilterItem = (item) => {
  emit("removeFilterItem", item);
};

function toggleActiveValue() {
  if (props.isAgendaActive) {
    emit("deactivateAgenda");
  } else {
    emit("activateAgenda");
  }
}
</script>

<style scoped>
.badge-tag {
  display: flex;
  min-width: 20px;
  height: 20px;
  padding: 0.1em 0.3em;

  border-radius: 12px;

  justify-content: center;
  align-items: center;
  line-height: initial;
  color: var(--clr-n8);
  font-size: 14px;
}
</style>
